import { arraysEqualIgnoreOrder } from "@redotech/util/equal";
import { ImmutableCountMap } from "@redotech/util/map";
import {
  ScanningAction,
  ScanningActionType,
  ScanningModal,
  ScanningState,
} from "./types";

export const initialScanningState: ScanningState = {
  _fulfillmentGroupIds: [],

  fulfillmentGroupIds: [],
  fulfillmentGroups: {},

  relevantFulfillmentGroups: [],
  scanned: ImmutableCountMap.empty(),
};

export function scanningStateReducer(
  state: ScanningState,
  action: ScanningAction,
): ScanningState {
  const newState = { ...state };

  switch (action.type) {
    case ScanningActionType.OPEN_MODAL:
      newState.modalState = action.payload.type;
      if ("data" in action.payload) {
        newState.modalData = action.payload?.data || undefined;
      }
      break;

    case ScanningActionType.CLOSE_MODAL:
      newState.modalState = undefined;
      break;

    case ScanningActionType.SET_FULFILLMENT_GROUPS:
      // should never be called for a different set of fulfillment groups
      // than is designated by state.fulfillmentGroupIds
      for (const group of action.payload) {
        if (!newState.fulfillmentGroupIds.includes(group._id)) {
          return state;
        }

        newState.fulfillmentGroups[group._id] = group;
      }
      break;

    case ScanningActionType.SET_FULFILLMENT_GROUP:
      if (newState._fulfillmentGroupId === action.payload) {
        return state;
      }

      newState._fulfillmentGroupId = action.payload;
      newState.modalState = undefined;
      newState.relevantFulfillmentGroups = [];
      newState.fulfillmentGroupIds = Array.from(
        new Set(
          [
            ...newState._fulfillmentGroupIds,
            newState._fulfillmentGroupId,
          ].filter(Boolean),
        ),
      ).sort();
      break;

    case ScanningActionType.SELECT_FULFILLMENT_GROUP:
      newState.modalState = ScanningModal.FULFILLMENT_GROUP_SELECTION;
      newState.relevantFulfillmentGroups = action.payload;
      break;

    case ScanningActionType.SET_PICK_SESSION:
      newState.pickSession = action.payload;
      newState._fulfillmentGroupIds = Array.from(
        new Set(
          newState.pickSession.items.map((item) => item.fulfillmentGroupId),
        ),
      );
      newState.fulfillmentGroupIds = Array.from(
        new Set(
          [
            ...newState._fulfillmentGroupIds,
            newState._fulfillmentGroupId,
          ].filter(Boolean) as string[],
        ),
      ).sort();
      newState.modalState = ScanningModal.TOTE_ORDER_SELECTION;
      break;

    case ScanningActionType.SET_FULFILLMENT_GROUP_DATA:
      if (
        action.payload &&
        newState._fulfillmentGroupId !== action.payload._id
      ) {
        return state;
      }

      newState.fulfillmentGroupData = action.payload;
      break;

    case ScanningActionType.SET_SCANNED:
      newState.scanned = action.payload;
      break;

    default:
      console.error("Unknown scanning action", action);
      return state;
  }

  if (
    !arraysEqualIgnoreOrder(
      state.fulfillmentGroupIds,
      newState.fulfillmentGroupIds,
    )
  ) {
    newState.fulfillmentGroups = {};
  }

  return newState;
}
